


























import Vue from "vue";
import {
  mdiInformationOutline,
  mdiHelpCircleOutline,
  mdiPlayCircleOutline,
} from "@mdi/js";
import Component from "vue-class-component";

@Component({
  name: "Navigation",
})
export default class Navigation extends Vue {
  info = mdiInformationOutline;
  help = mdiHelpCircleOutline;
  play = mdiPlayCircleOutline;

  buttons = [
    { label: "New game", event: "new-game", icon: this.play },
    { label: "Show solution", event: "show-solution", icon: this.help },
    { label: "How to play", event: "show-help", icon: this.info },
  ];
}
